import { render, staticRenderFns } from "./fapiaoMsg.vue?vue&type=template&id=fb9138b6&scoped=true"
import script from "./fapiaoMsg.vue?vue&type=script&lang=js"
export * from "./fapiaoMsg.vue?vue&type=script&lang=js"
import style0 from "./fapiaoMsg.vue?vue&type=style&index=0&id=fb9138b6&prod&lang=scss"
import style1 from "./fapiaoMsg.vue?vue&type=style&index=1&id=fb9138b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9138b6",
  null
  
)

export default component.exports